import Styles from './Dropdown.scss';

import Template from './Dropdown.hbs';
import DropdownItem from 'views/components/heroButton/heroDropdown/dropdownItem/DropdownItem'
import Button from '../button/Button';

export default class Dropdown extends BaseView {

    initialize({ label, icon, iconRight, theme, dropdownItems, positionFromLeft, positionFromBottom }) {
        _.bindAll(
            this,
            'onClickDocument',
            'onClickButton',
            'renderDropdownItem'
        );

        this.isOpen = false;

        this.setElement(Template({
            Styles,
            positionFromLeft,
            positionFromBottom
        }))

        this.button = this.addChildView(
            new Button({
                label,
                icon,
                iconRight,
                theme,
                callback: this.onClickButton
            }),
            '.js-dropdown-button'
        )

        _.each(dropdownItems, this.renderDropdownItem);
    }

    open() {
        this.$('.js-dropdown-list').show({
            complete: () => {
                $(document).on('click', this.onClickDocument)
                this.isOpen = true
            }
        })
    }

    close() {
        this.$('.js-dropdown-list').hide()
        $(document).off('click', this.onClickDocument)
        this.isOpen = false
    }

    // do not execute the first click if it's not targeting the dropdown
    onClickDocument(e) {
        // if the target of the click isn't the container this.$el...
        if (!this.$('.js-dropdown-list').is(e.target) &&

            // ... nor a descendant of the container this.$el
            this.$('.js-dropdown-list').has(e.target).length === 0
        ) {
            this.close()
        }

        return false
    }

    onClickButton() {
        if (!this.isOpen) {
            this.open()
        } else {
            this.close()
        }
    }

    renderDropdownItem(itemOptions) {
        this.addChildView(
            new DropdownItem(itemOptions),
            '.js-dropdown-list'
        );
    }
}
